import { PlanUpdateDialogChip } from "@/pages/Plannn/components/table/PlanUpdateDialog";
import { PlanEditableKeys } from "@/stores/use-plan-table";
import { NotificationCategoriesListWithDetails } from "@/types/global";

/**
 * Displays notification context changes as chips for specific notification categories.
 * Shows field modifications in plan-related notifications.
 */
function NotificationChanges({ changes, category }: { changes: unknown; category: string }) {
    if (
        !changes ||
        !Array.isArray(changes) ||
        !changes.length ||
        !category ||
        !NotificationCategoriesListWithDetails.includes(
            category as (typeof NotificationCategoriesListWithDetails)[number]
        )
    )
        return null;

    const validChanges = changes.filter(
        (item) => typeof item === "string" && PlanEditableKeys.includes(item as (typeof PlanEditableKeys)[number])
    );
    if (!validChanges.length) return null;

    return (
        <div className="grid grid-cols-1   sm:grid-cols-2 md:grid-cols-3  mt-1 gap-2 p-2 text-xs italic font-normal text-gray-500 border border-gray-200 rounded-lg bg-gray-50  mx-1">
            {validChanges.map((change, index) => (
                <div key={index}>
                    <PlanUpdateDialogChip label={change} />
                </div>
            ))}
        </div>
    );
}

export default NotificationChanges;
